export const testimonials = [
  {
    id: 1,
    name: "林女士",
    location: "台中",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20mature%20elegant%20taiwanese%20woman%2050s%20professional%20warm%20smile%20cream%20background%20graceful%20well%20dressed&width=120&height=120&seq=av001&orientation=squarish",
    rating: 5,
    comment: "穿上之後真的很顯瘦！版型修飾了我的身材，面料摸起來很有質感。Outlet 的價格卻有正品的品牌感，非常值得。",
    purchasedItem: "都會氣質修身洋裝",
    highlight: "版型修飾身材，質感超乎期待",
  },
  {
    id: 2,
    name: "陳女士",
    location: "台中",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20elegant%20taiwanese%20woman%2045s%20professional%20gentle%20smile%20beige%20background%20graceful%20sophisticated&width=120&height=120&seq=av002&orientation=squarish",
    rating: 5,
    comment: "已經是第三次回購了！每次穿出去都被詢問在哪裡買的。設計師的剪裁就是不一樣，穿起來氣質完全提升。",
    purchasedItem: "優雅職場西裝外套",
    highlight: "回購三次，每次都滿意",
  },
  {
    id: 3,
    name: "王小姐",
    location: "台中",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20mature%20professional%20taiwanese%20woman%2050s%20elegant%20warm%20neutral%20background%20confident%20poised&width=120&height=120&seq=av003&orientation=squarish",
    rating: 5,
    comment: "之前一直不知道在哪裡買到有質感又不會太貴的衣服。這裡完全符合我的需求，服務也很親切，會幫忙挑適合自己的款式。",
    purchasedItem: "典雅修身套裝組",
    highlight: "品質與價格完美平衡",
  },
];

export const lookbookItems = [
  {
    id: 1,
    title: "通勤氣質穿搭",
    subtitle: "俐落、專業又不失優雅",
    image: "https://readdy.ai/api/search-image?query=elegant%20taiwanese%20mature%20woman%20commute%20office%20outfit%20blazer%20professional%20graceful%20urban%20style%20cream%20beige%20warm%20neutral%20background%20designer%20fashion&width=500&height=620&seq=lb001&orientation=portrait",
  },
  {
    id: 2,
    title: "熟齡優雅穿搭",
    subtitle: "展現成熟女性自信魅力",
    image: "https://readdy.ai/api/search-image?query=elegant%20mature%20taiwanese%20woman%2050s%20graceful%20outfit%20midi%20dress%20sophisticated%20style%20soft%20rose%20dusty%20pink%20background%20designer%20fashion%20quality&width=500&height=620&seq=lb002&orientation=portrait",
  },
  {
    id: 3,
    title: "顯瘦修飾穿搭",
    subtitle: "聰明選搭，輕鬆展現好身材",
    image: "https://readdy.ai/api/search-image?query=elegant%20slim%20taiwanese%20mature%20woman%20slimming%20outfit%20wide%20leg%20pants%20flowy%20top%20graceful%20urban%20cream%20warm%20neutral%20background%20designer%20fashion&width=500&height=620&seq=lb003&orientation=portrait",
  },
];
